import React from "react";
import SingleChoice from "./partials/singleChoice";
import TextUpload from "./partials/TextUpload";
import YesNoUpload from "./partials/YesNoUpload";
import YesNoText from "./partials/YesNoText";
import MultipleChoice from "./partials/multiChoice";
import UnitText from "./partials/UnitText";
import NPS from "./partials/NPS";
import YesNoSingleChoice from "./partials/YesNoSingleChoice";
import "./style.scss";
import { Spinner } from "react-bootstrap";
import { removeSpaceAndUppercase } from "../../../../functions/common";
import { QUESTION_TYPES } from "../../../../utils/data";
import SingleChoiceText from "./partials/singleChoiceText";

const QuestionBox = ({
  currentQuestion,
  handleAnswer,
  uploadLoading,
  setUploadLoading,
  answers,
  handleMultiQuesAnswer,
  handleNext,
  nextDisabled,
  loading,
  currentIndex,
}) => {
  // const isQuestionAnswered = answersDone?.[currentQuestion?.refCode];
  // const isRequired = currentQuestion?.isRequired;
  // const isAllRequiredFilled = (isQuestionAnswered || !isRequired ? Object.keys(requiredAnswersDone)?.length : (Object.keys(requiredAnswersDone)?.length)+1)  === requiredQuestions?.length;
  const responseType = removeSpaceAndUppercase(currentQuestion?.responseType);
  const withText = currentQuestion?.responseType?.includes("+ Text");
  const description = currentQuestion?.shortDescriptionOfQuestion?.includes("\n")
    ? `${(currentQuestion?.shortDescriptionOfQuestion ?? "").replace(
        /\n/g,
        "<br />"
      )?.replace("<br />","<br /><br /> <span>")}</span>`
    : currentQuestion?.shortDescriptionOfQuestion;

  return (
    <div className="question__and__options__box">
      <div className="question__box__header">
        <h5
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        {/* <h5>
                    {currentQuestion?.criteria ?? ''}
                </h5> */}
      </div>
      <div className="question__box__description">
        <div className="question__sub__box__descripton">
          {responseType ===
            removeSpaceAndUppercase(QUESTION_TYPES.SINGLECHOICE) && (
            <SingleChoice
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              uploadLoading={uploadLoading}
              setUploadLoading={setUploadLoading}
              currentIndex={currentIndex}
            />
          )}
          {responseType ===
            removeSpaceAndUppercase(QUESTION_TYPES.SINGLECHOICETEXT) && (
            <SingleChoiceText
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              uploadLoading={uploadLoading}
              setUploadLoading={setUploadLoading}
              currentIndex={currentIndex}
            />
          )}

          {responseType === removeSpaceAndUppercase(QUESTION_TYPES.TEXT) ||
          responseType ===
            removeSpaceAndUppercase(QUESTION_TYPES.NUMERICVALUE) ? (
            <TextUpload
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              uploadLoading={uploadLoading}
              setUploadLoading={setUploadLoading}
              currentIndex={currentIndex}
              numeric={responseType ===
              removeSpaceAndUppercase(QUESTION_TYPES.NUMERICVALUE)}
            />
          ) : (
            ""
          )}

          {responseType === removeSpaceAndUppercase(QUESTION_TYPES.YESNO) ||
          (responseType?.includes(
            removeSpaceAndUppercase(QUESTION_TYPES.YESNONOTAPPLICABLE)
          ) &&
            !withText) ? (
            <YesNoUpload
              uploadLoading={uploadLoading}
              setUploadLoading={setUploadLoading}
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              currentIndex={currentIndex}
              notApplicable={responseType?.includes(
                removeSpaceAndUppercase(QUESTION_TYPES.YESNONOTAPPLICABLE)
              )}
              responseType={currentQuestion?.responseType}
            />
          ) : (
            ""
          )}

          {(responseType ===
            removeSpaceAndUppercase(QUESTION_TYPES.YESNOTEXT) ||
            (removeSpaceAndUppercase(responseType)?.includes(
              removeSpaceAndUppercase(QUESTION_TYPES.YESNONOTAPPLICABLE)
            ) &&
              withText)) && (
            // ||  currentQuestion?.responseType === "YN+AL-Text")
            <YesNoText
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              uploadLoading={uploadLoading}
              setUploadLoading={setUploadLoading}
              currentIndex={currentIndex}
              notApplicable={responseType?.includes(
                removeSpaceAndUppercase(QUESTION_TYPES.YESNONOTAPPLICABLE)
              )}
              responseType={currentQuestion?.responseType}
            />
          )}

          {currentQuestion?.type === "multiQues" && (
            <MultipleChoice
              data={currentQuestion}
              handleAnswer={handleMultiQuesAnswer}
              answers={answers}
              currentIndex={currentIndex}
            />
          )}

          {currentQuestion?.responseType === "YN + SC" && (
            <YesNoSingleChoice
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              currentIndex={currentIndex}
            />
          )}

          {currentQuestion?.responseType === "SC-UNIT+TEXT" && (
            <UnitText
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              currentIndex={currentIndex}
            />
          )}

          {responseType ===
            removeSpaceAndUppercase(QUESTION_TYPES.NUMERIC100) && (
            <NPS
              data={currentQuestion}
              handleAnswer={handleAnswer}
              answers={answers}
              uploadLoading={uploadLoading}
              setUploadLoading={setUploadLoading}
              currentIndex={currentIndex}
            />
          )}
          {/* {isLastQuestion ? <div className='next__and__skip'>
                        <button className='mw-100' disabled={nextDisabled || loading || uploadLoading || !isAllRequiredFilled} onClick={() => handleNext(false, false, 'COMPLETED')}>
                            SUBMIT ASSESSMENT
                        </button>
                        <div className='submit__points'>
                            <ul>
                                <li>
                                The "Submit Assessment" button will activate once all required questions (*) are answered.
                                </li>
                                <li>
                                Unanswered required questions are marked with a greyed-out check circle in the left-hand navigation bar.
                                </li>
                                <li>
                                Please review your responses carefully before submitting. Submissions are final, and answers cannot be edited afterward.
                                </li>
                            </ul>
                            </div>
                    </div> :
                        
                    } */}
          <div className="next__and__skip">
            <button
              disabled={nextDisabled || loading || uploadLoading}
              onClick={() => handleNext(false)}
            >
              {loading ? <Spinner animation="border" role="status" /> : "NEXT"}
            </button>
            <button onClick={() => handleNext(true)} className="skip__btn">
              Skip for Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionBox;
